import { render, staticRenderFns } from "./ipasasFaPermissionsSearch.vue?vue&type=template&id=6c75ae7a&"
import script from "./ipasasFaPermissionsSearch.vue?vue&type=script&lang=js&"
export * from "./ipasasFaPermissionsSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports